



































import { Vue, Component, Watch } from 'vue-property-decorator';
import VoteButton from '@/components/VoteButton.vue';
import { Toast } from 'vant';
import * as config from './config';
import { namespace } from 'vuex-class';
import { DetailData, ContentParam } from './store/types';
const Modules = namespace('HealthContributionBrand2019');
Vue.use(Toast);
@Component({
  components: {
    VoteButton,
  },
})
export default class DetailPage extends Vue {
  @Modules.Action getDetail!: (param: ContentParam) => void;
  @Modules.Action updateVoteNumber!: () => void;
  @Modules.State('detailData') detailData!: DetailData;
  @Modules.State('coverImg') coverImg!: string;
  @Modules.State('contentData') contentData!: string;
  @Modules.State('button') button!: boolean;
  options = config.OPTHINES;

  async created() {
    await this.getDetail({ id: this.$route.query.id, type: this.$route.query.type });
    // console.log('detailData.content',this.detailData.content)
  }
  getDetailAsync() {
    return new Promise((resolve, reject) => {
    this.getDetail({ id: this.$route.query.id, type: this.$route.query.type });
    if (this.detailData.id) {
      resolve();
    } else {
      reject();
    }
    });
  }
  votSuccess() {
    this.updateVoteNumber();
  }
}
